import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useTabSync = (defaultTab: string) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState<string>(defaultTab);

  useEffect(() => {
    const newTab = new URLSearchParams(location.search).get('tab');
    if (newTab && newTab !== activeKey) {
      setActiveKey(newTab);
    }
  }, [activeKey, location.search]);

  const updateUrl = (tab: string) => {
    setActiveKey(tab);
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('tab', tab);
    navigate({ search: searchParams.toString() }, { replace: true });
  };

  return { activeKey, location, updateUrl };
};
